/**
 * Takes a number and transforms it a roman one
 * e.g. 9 --> IX
 */
export const transformToRomanNumber = (numberToTranslate: number): string => {
  let result = ''

  romanSymbols.forEach(number => {
    while (numberToTranslate >= number.value) {
      result += number.symbol
      numberToTranslate -= number.value
    }
  })

  return `${result}.`
}

const romanSymbols: { value: number; symbol: string }[] = [
  { value: 1000, symbol: 'M' },
  { value: 900, symbol: 'CM' },
  { value: 500, symbol: 'D' },
  { value: 400, symbol: 'CD' },
  { value: 100, symbol: 'C' },
  { value: 90, symbol: 'XC' },
  { value: 50, symbol: 'L' },
  { value: 40, symbol: 'XL' },
  { value: 10, symbol: 'X' },
  { value: 9, symbol: 'IX' },
  { value: 5, symbol: 'V' },
  { value: 4, symbol: 'IV' },
  { value: 1, symbol: 'I' },
]
